export default class FormValue {
  
  constructor(value){
    this._value = value;
    this._original = value;
  }

  set value(v){
    this._value = v;
    this.modified = true;
  }

  get value(){
    return this._value;
  }

  reset(){
    this._value = this._original;
    this.modified = false;
  }

  setModified(){
    this.modified = true;
  }

}


// WEBPACK FOOTER //
// ./src/Editor/FormValue.js